module.exports = __webpack_public_path__ + "img/DSC0405 03.cf9a3f33.jpg";